<template>
  <div>
    <b-row :style="`background-color:${screen.bgColor}; height: 50vh`">
      <b-col cols>
        <div id="roomContainer"
             style="height: 50%;
        "/>
        <div id="publisher"
        class="publisher-video"
        />
        <div id="publisherScreenShare" style="height: 100px; border-radius: 25px"/>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <session-controls
            :is-av-avail="isAVSetUp"
            :is-session-avail="isAuthToJoinRoom"
            :toggle="toggle"
            :av-resources="avresources"
            @button-toggle="handleButtonToggle"
            @leave-room-click="handleLeaveRoom"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Room } from "@vonage/video-express";
import SessionControls from "./controls";
export default {
  name: "Sessions_Stage",
  components: {
    SessionControls,
  },
  props: {
    session: {
      type: Object,
      default: () => {}
    },
    profile: {
      type: Object,
      default: () => {}
    },
    roomdata: {
      type: Object,
      default: () => {}
    },
    avresources: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    if (this.roomdata.token){
      this.joinRoom();
    }
  },
  computed: {
    isRoomAvail(){
      return  !!(this.roomdata.apiKey && this.roomdata.sessionId);
    },
    isAVSetUp(){
      return !!(this.avresources.selectedAudio && this.avresources.selectedVideo);
    },
    isAuthToJoinRoom(){
      return !!this.roomdata.token;
    },
    isScreenSharing(){
      return !!(this.room && this.room.screen && this.room.screen.isScreenSharing);
    }

  },
  methods: {
    handleSettingsPopOverClick(){
      this.showMenuPopover = !this.showMenuPopover;
    },
    handleAddDataButtonClick() {
       this.$emit('add-data-click');
    },
    async joinRoom() {
      return new Promise(async (res, rej) => {
        console.log("joinRoom room: ", this.room);

        if (!this.room) {
          console.log("create a new room");
          this.room = new Room({
            apiKey: this.roomdata.apiKey, // add your OpenTok APIKey
            sessionId: this.roomdata.sessionId, // add your OpenTok Session Id
            token: this.roomdata.token, // add your OpenTok token
            participantName: this.roomdata.participantName,
            roomContainer: "roomContainer",
            managedLayoutOptions: {
              cameraPublisherContainer: "publisher"
            }
          });
        }

        const {camera, screen} = this.room;

        this.camera = camera;
        const publisherOptions = {
          insertMode: 'append',
          width: '100%',
          height: '100%'
        };

       //this.publisher = camera.initPublisher('publisher', publisherOptions);

       try {
          let pubProps = {
            resolution: "1280x720",
            [this.avresources.selectedAudio === "" ? "publishAudio" : "audioSource"]:
                this.avresources.selectedAudio === "" ? false : this.avresources.selectedAudio,
            [this.avresources.selectedVideo === "" ? "publishVideo" : "videoSource"]:
                this.avresources.selectedVideo === "" ? false : this.avresources.selectedVideo,
            mirror: true,
            audioBitrate: 6000,
            audioFallbackEnabled: true
          };
          await this.room.join({
            publisherProperties: pubProps
          });

        } catch (error) {
          rej(error);
          console.error("Error joining room: ", error)``;
        }

        this.status.isAudioEnabled = this.camera.isAudioEnabled() ? true : false;
        this.status.isVideoEnabled = this.camera.isVideoEnabled() ? true : false;

        screen.on("started", () => {
          this.toggle.isScreenSharing = true;
          console.log("The screen sharing has started!");
        });

        screen.on("stopped", () => {
          this.toggle.isScreenSharing = false;
          console.log("The screen stopped sharing because: ");
        });

        this.room.on("connected", async () => {
          console.log("room connected!");
        });

        this.room.on("participantJoined", participant => {
          console.log("participantJoined: ", participant);
          participant.on("cameraCreated", cameraSubscriber => {
            console.log("Participant camera created! ", cameraSubscriber);
          });
          participant.on("cameraDestroyed", reason => {
            console.log("Participant camera destroyed!", reason);
          });
          participant.on("screenCreated", screenSubscriber => {
            console.log("Participant Screen created!", screenSubscriber);
          });
          participant.on("screenDestroyed", reason => {
            console.log("Participant Screen destroyed!", reason);
          });
          participant.on("destroyed", reason => {
            console.log("Participant Screen destroyed!", reason);
          });
        });

        this.room.on("disconnected", () => {
          console.log("room disconnected!");
        });

        this.room.on("reconnecting", () => {
          console.log("room reconnecting!");
        });

        this.room.on("reconnected", () => {
          console.log("room reconnected!");
        });

        res(true);
      });
    },
    /** CONTROLS **/
    handleButtonToggle(toggleItem){
      switch (toggleItem){
        case "audio":
          this.handleToggleAudio();
          break;
        case "video":
          this.handleToggleVideo();
          break;
        case "layout":
          this.handleToggleLayout();
          break;
        case "hand":
          this.handleToggleHandRaise();
          break;
        case "settings":
          this.handleToggleSettings();
          break;
        case "screenshare":
          this.handleToggleScreenShare();
          break;
          default:
            break;
      }
    },
    handleToggleVideo() {
      if (this.camera) {
        console.log(
            "camera.isVideoEnabled()",
            this.camera.isVideoEnabled()
        );

        if (this.camera.isVideoEnabled()) {
          this.camera.disableVideo();
           this.status.isVideoEnabled = false;
        } else {
          this.camera.enableVideo();
          this.status.isVideoEnabled = true;
        }
      }
    },
    handleToggleAudio() {
      if (this.camera) {
        if (this.camera.isAudioEnabled()) {
          this.camera.disableAudio();
          this.status.isAudioEnabled = false;
        } else {
          this.camera.enableAudio();
          this.status.isAudioEnabled = true;
        }
      }
    },
    handleToggleLayout() {
      if (this.camera) {
        console.log(`Layout Status is  ${this.status.layoutStatus}`);
        if (this.status.layoutStatus === "grid") {
          this.room.setLayoutMode("active-speaker");
          this.status.layoutStatus = "active speaker";
        } else {
          this.room.setLayoutMode("grid");
          this.status.layoutStatus = "grid";
        }
      }
    },
    handleToggleHandRaise() {},
    handleToggleSettings(){
      this.toggle.showSettings = !this.toggle.showSettings;
    },
    handleToggleScreenShare() {
      if (this.isScreenSharing) {
        this.room.stopScreensharing();
      } else {
        this.room.startScreensharing("publisherScreenShare");
      }
    },
    handleLeaveRoom() {
      if (this.room) {
        this.roomdata.token = null;
        this.room.token = null;
        this.room.leave();
      }
    }
  },
  data() {
    return {
      showMenuPopover: false,
      screen: {
        bgColor: "#222222"
      },
      room: null,
      roomRef: "",
      participantRef: "",
      stageRoomId: this.session && this.session.id ? this.session.id : null,
      participantName:
          this.profile && this.profile.firstname ? this.profile.firstname : null,
      toggle: {
        showSettings: false
      },
      status: {
        isVideoEnabled: null,
        isAudioEnabled: null,
        roomStatus: null,
        layoutStatus: "",
      },
      camera: null,
      unsubRoom: null,
      unsubUser: null,
      publisher: null
    };
  }
};
</script>

<style lang="scss" scoped>
.publisher-video {
  position: absolute;
  right: 50%;
  bottom: 25%;
  cursor: pointer;
  width:100%;
  border-radius: 25px;
}

#publisher
{
  width: 100px;
  height: 100px; }
@media screen and (max-width: 650px) {
  #publisher {
    width: 89px;
    height: 50px;
  }
}
</style>
